import { proxy } from 'valtio'

/**
 * Valtio Store - Replaces Redux store
 * 
 * State structure:
 * - requests: Cache for API responses keyed by request identifier
 * - pendingRequests: Track in-flight requests for ResponseStatus component
 */
export const store = proxy({
  requests: {},      // requestKey -> Response object
  pendingRequests: {} // requestId -> { requestKey, status }
})

/**
 * Store a request response in the cache
 */
export function setRequestResponse(key, response) {
  store.requests[key] = response
}

/**
 * Clear a request response from the cache
 */
export function clearRequestResponse(key) {
  delete store.requests[key]
}

/**
 * Get a cached response
 */
export function getRequestResponse(key) {
  return store.requests[key] || null
}

/**
 * Track a pending request
 */
export function addPendingRequest(requestId, requestKey) {
  store.pendingRequests[requestId] = { requestKey, status: 'pending' }
}

/**
 * Remove a pending request
 */
export function removePendingRequest(requestId) {
  delete store.pendingRequests[requestId]
}

/**
 * Get count of pending requests
 */
export function getPendingRequestCount() {
  return Object.keys(store.pendingRequests).length
}
